export default __webpack_public_path__ + "static/4b247595c875d5cdcca2af75b35af684.png";